import type {
  BodySizeDto,
  BodyTypographyDto,
  ButtonDto,
  ButtonsDto,
  ColorCollectionDto,
  ColorDto,
  HeadingLevelDto,
  HeadingTypographyDto,
  LinkStyleDto,
  StylesConfigDto,
  TypographyDto,
  TypographySizeDto,
} from '../dto/styles';

export type TextAlign = 'left' | 'right' | 'center';

export type FontStyle = 'normal' | 'italic';

// TODO replace type aliases with real DTO type once code has settled
export type Color = ColorDto;

export type HeadingLevel = HeadingLevelDto;
export type HeadingTypography = HeadingTypographyDto;
export type BodySizeLevel = BodySizeDto;
export type BodyTypography = BodyTypographyDto;
export type TypographySize = TypographySizeDto;
export type LinkStyle = LinkStyleDto;
export type Button = ButtonDto;
export type StyleColors = ColorCollectionDto;
export type StyleTypography = TypographyDto;
export type StyleButtons = ButtonsDto;
export type StylesConfig = StylesConfigDto;

export type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
export type BodySize = 'small' | 'medium' | 'large';
export type LinkVariant = 'link1' | 'link2';

// Single source of truth for link variant values.
// Keep in sync with the LinkVariant type above and any validator that references these values
// (e.g. IsTextStyles.ts).
export const LINK_VARIANT_VALUES = ['link1', 'link2'] as const satisfies ReadonlyArray<LinkVariant>;
